import Axios from '../libs/axios/Axios';

import {
  createEventValueRangeQueryClient,
  createIconsQueryClient,
  createDevicesQueryClient,
  createMapSettingsQueryClient,
  createInitialConfigQueryClient,
  createDeviceConfigQueryClient,
  createDeviceCountersQueryClient,
  createDeviceLocationsQueryClient,
  createDeviceStatisticsQueryClient,
  createDeviceFlowQueryClient,
  createAutoRelayQueryClient,
  createCommandQueryClient,
  createUserQueryClient,
} from '@thingslog/queries';
import { createAlarmsExportQueryClient } from '@thingslog/queries';
import { createFeatureFlagsQueryClient } from '@thingslog/queries';
import { createDevicesIconsQueryClient } from '@thingslog/queries';
import { createSettingsQueryClient } from '@thingslog/queries';
import { createCompanyInfoQueryClient } from '@thingslog/queries';
import { createScheduledEventsQueryClient } from '@thingslog/queries';
import { createLicenseQueryClient } from '@thingslog/queries';
import { createTrashbagsQueryClient } from '@thingslog/queries';

export const eventValueRangeQueryClient = createEventValueRangeQueryClient(Axios);
export const alarmsQueryClient = createAlarmsExportQueryClient(Axios);
export const featureFlagsQueryClient = createFeatureFlagsQueryClient(Axios);
export const devicesIconsQueryClient = createDevicesIconsQueryClient(Axios);
export const settingsQueryClient = createSettingsQueryClient(Axios);
export const companyInfoQueryClient = createCompanyInfoQueryClient(Axios);
export const scheduledEventsQueryClient = createScheduledEventsQueryClient(Axios);
export const iconsQueryClient = createIconsQueryClient(Axios);
export const devicesQueryClient = createDevicesQueryClient(Axios);
export const mapSettingsQueryClient = createMapSettingsQueryClient(Axios);
export const initialConfigQueryClient = createInitialConfigQueryClient(Axios);
export const deviceConfigQueryClient = createDeviceConfigQueryClient(Axios);
export const deviceCounterQueryClient = createDeviceCountersQueryClient(Axios);
export const deviceLocationQueryClient = createDeviceLocationsQueryClient(Axios);
export const deviceStatisticsQueryClient = createDeviceStatisticsQueryClient(Axios);
export const deviceFlowQueryClient = createDeviceFlowQueryClient(Axios);
export const autoRelayQueryClient = createAutoRelayQueryClient(Axios);
export const licenseQueryClient = createLicenseQueryClient(Axios);
export const commandQueryClient = createCommandQueryClient(Axios);
export const trashbagsQueryClient = createTrashbagsQueryClient(Axios);
export const userQueryClient = createUserQueryClient(Axios);
